import { render, staticRenderFns } from "./orderHistory.vue?vue&type=template&id=d1c9b06c&scoped=true&"
import script from "./orderHistory.vue?vue&type=script&lang=ts&"
export * from "./orderHistory.vue?vue&type=script&lang=ts&"
import style0 from "./orderHistory.vue?vue&type=style&index=0&id=d1c9b06c&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1c9b06c",
  null
  
)

export default component.exports